export const CHAT_FAQ_SCOPES = [
  { value: 'GENERAL', label: 'General' },
  { value: 'PRODUCT', label: 'Product policy' },
  { value: 'ORDER', label: 'Order policy' },
  { value: 'SHIPMENT', label: 'Shipment policy' },
  { value: 'PAYMENT', label: 'Payment policy' }
]

export const getChatFaqScopeLabel = scope => CHAT_FAQ_SCOPES
  .find(option => option.value === (scope || 'GENERAL'))?.label || 'General'
